module.exports = __webpack_public_path__ + "assets/persona_Landscape_1920x1080.png";


//////////////////
// WEBPACK FOOTER
// ./images/ai-preview/persona_Landscape_1920x1080.png
// module id = 705
// module chunks = 0